import { render, staticRenderFns } from "./PartnerEditing.vue?vue&type=template&id=21c79536"
import script from "./PartnerEditing.vue?vue&type=script&lang=js"
export * from "./PartnerEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports